// SocketGuard.jsx
import React, { useEffect } from "react";
import { initSocket, closeSocket, socket } from "./socket";

const SocketGuard = ({ children }) => {
  const token = window.localStorage.getItem("accessToken") || "";

  useEffect(() => {
    // 1. Connect (with the latest token)
    initSocket(token);

    // 2. Global listeners (optional—useful for debug/logging)
    const onConnect = () => console.log("Socket connected:", socket.id);
    const onDisconnect = (reason) =>
      console.log("Socket disconnected:", reason);

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    // 3. Cleanup on unmount or token change
    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      closeSocket();
    };
  }, [token]);

  return <>{children}</>;
};

export default SocketGuard;
